import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Input from '../input';
import Popup from './';
import Checkbox from '../checkbox';

class VacancyPopup extends Component {
  static propTypes = {
    route: PropTypes.string.isRequired,
    name: PropTypes.string,
  };

  static defaultProps = {
    name: '',
  };

  state = {
    sendData: false,
    error: null,
    success: false,
    file: null,
    accept_rules: 0,
    key: 0,
  };

  addFile = e => {
    this.setState({
      file: true,
    });
  };

  deleteFile = () => {
    this.setState({
      file: null,
      key: this.state.key + 1,
    });
  };

  confirm = e => {
    e.preventDefault();

    const { route } = this.props;

    let formData = new FormData(this.form);

    let headers = {
      method: 'POST',
      body: formData,
      headers: {},
    };

    this.setState({
      sendData: true,
      error: null,
    });

    // for (var pair of formData.entries()) {
    // 	console.log(pair[0]+ ', ' + pair[1]);
    // }

    fetch(route, headers)
      .then(response => response.json())
      .then(json => {
        if (json.status == 'success') {
          this.setState({
            sendData: false,
            error: null,
            success: true,
          });
        } else {
          let err = 'Что-то пошло не так. Попробуйте еще раз.';

          if ('message' in json.errors) {
            err = json.errors.message;
          } else if ('join' in json.errors && json.errors.length > 0) {
            err = `${json.errors[0].title + '. ' || ''}${json.errors[0]
              .detail || 'Что-то пошло не так. Попробуйте еще раз.'}`;
          }

          this.setState({
            sendData: false,
            error: err,
          });
        }
      })
      .catch(error => {
        this.setState({
          sendData: false,
          error: 'Что-то пошло не так. Попробуйте еще раз.',
        });
      });
  };

  render() {
    const { sendData, error, success, file, key, accept_rules } = this.state;
    const { name } = this.props;

    if (success)
      return (
        <Popup
          type="alert"
          status="success"
          title="Отлично!"
          message="Ваш отклик отправлен."
          button="Назад"
        />
      );

    let btnClasses = ['btn'];

    if (sendData) btnClasses.push('btn--loading');

    return (
      <div className="popup" data-type="vacancy">
        <div className="popup__aside">
          <div className="card-popup__pic" />
        </div>
        <form className="popup__content" ref={node => (this.form = node)}>
          <div className="popup__content-inner">
            <div className="popup__section-title">
              <h3 className="heading heading--1 popup__title">
                Отклик на вакансию
              </h3>
            </div>
            <div className="inp-group">
              <div className="row">
                <div className="inp-group__case">
                  <Input
                    label="ФИО"
                    name="name"
                    placeholder="Как к вам обращаться?"
                    indie
                  />
                </div>
                <div className="inp-group__case">
                  <Input
                    label="Дата рождения"
                    name="birthday"
                    date
                    placeholder="дд.мм.гггг"
                    indie
                  />
                </div>
                <div className="inp-group__case">
                  <Input
                    label="Как с вами связаться?"
                    name="contacts"
                    placeholder="E-mail или номер телефона"
                    indie
                    required={true}
                  />
                </div>
                <div className="inp-group__case">
                  <Input
                    label="Интересующая вакансия"
                    name="vacancy"
                    placeholder="Какая вакансия вас интересует?"
                    value={name || ''}
                    indie
                  />
                </div>
                <div className="inp-group__case">
                  <Checkbox
                    checked={accept_rules == 1}
                    name="accept_rules"
                    value={accept_rules}
                    label={
                      'Согласие на\u00A0обработку персональных\u00A0данных'
                    }
                  />
                </div>
              </div>
              {file ? (
                <div className="row">
                  <div className="inp-group__case">
                    <div className="file-item">
                      <p>
                        Файл
                        <button
                          type="button"
                          onClick={this.deleteFile}
                        ></button>
                      </p>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
            <div className="popup__btn-wrap">
              {error ? <p>{error}</p> : null}
              <div className="wrap">
                <button className={btnClasses.join(' ')} onClick={this.confirm}>
                  Откликнуться
                </button>
                <label
                  className="btn btn--file btn--outline"
                  style={file ? { display: 'none' } : null}
                >
                  <input
                    ref={node => (this.file = node)}
                    key={key}
                    type="file"
                    name="file"
                    onChange={this.addFile}
                  />
                </label>
              </div>
            </div>
          </div>
        </form>
        <button className="popup__close" type="button">
          <svg viewBox="0 0 18 18" width="18" height="18">
            <path d="M15.5 17.6l-6.5-6.5-6.5 6.5c-.6.6-1.5.6-2.1 0-.6-.6-.6-1.5 0-2.1l6.5-6.5-6.5-6.5c-.6-.6-.6-1.5 0-2.1.6-.6 1.5-.6 2.1 0l6.5 6.5 6.5-6.5c.6-.6 1.5-.6 2.1 0 .6.6.6 1.5 0 2.1l-6.5 6.5 6.5 6.5c.6.6.6 1.5 0 2.1-.3.3-.6.4-1 .4s-.8-.2-1.1-.4z"></path>
          </svg>
        </button>
      </div>
    );
  }
}

export default VacancyPopup;
